interface NavAttributes {
  [propName: string]: any;
}

interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}

interface NavBadge {
  text: string;
  variant: string;
}

interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

export const navItems: NavData[] = [
  {
    name: 'Menu',
    url: '/nav-usermanager',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    name: '',
    url: '/user-management',
    icon: 'icon-puzzle',
    children: [
      // {
      //   name: 'Example Data',
      //   url: '/master/example',
      //   icon: 'icon-puzzle'
      // },
      {
        name: 'Aplikasi',
        url: '/user-management/aplikasi',
        icon: 'icon-puzzle'
      },
      {
        name: 'Otoritas',
        url: '/user-management/otoritas',
        icon: 'icon-puzzle'
      },
      {
        name: 'Kelola Otoritas',
        url: '/user-management/kelola-otoritas'
      },
      {
        name: 'Pengguna',
        url: '/user-management/pengguna',
        icon: 'icon-puzzle'
      },
      {
        name: 'Menu',
        url: '/user-management/menu',
        icon: 'icon-puzzle'
      },
      {
        name: 'Profil Sekolah',
        url: '/user-management/sekolah',
        icon: 'icon-puzzle'
      }
    ]
  },
  {
    name: '',
    url: '/bos-negeri',
    icon: 'icon-puzzle',
    children: [
      {
        name: 'Input BKU BOSP',
        url: '/bos-negeri/input-bku',
        icon: 'icon-puzzle'
      },
      {
        name: 'Pengajuan BKU BOSP',
        url: '/bos-negeri/pengajuan-bku',
        icon: 'icon-puzzle'
      },
      {
        name: 'Persetujuan BKU BOSP',
        url: '/bos-negeri/persetujuan-bku',
        icon: 'icon-puzzle'
      }
    ]
  }
];
